import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UserpilotService } from '@infodocs/shared/services/userpilot.service';
import { setTheme } from 'ngx-bootstrap/utils';
import { filter } from 'rxjs';
import { EVENT_LOGGER_SERVICE } from '@infodocs/shared/modules/event-logging/token';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [RouterOutlet],
})
export class AppComponent {
	title = 'infodocs';
	private readonly router = inject(Router);
	private readonly eventLoggerService = inject(EVENT_LOGGER_SERVICE);
	private readonly userpilotService = inject(UserpilotService);

	constructor() {
		setTheme('bs5');

		this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
			.subscribe((event) => {
				this.eventLoggerService.logEvent('Page view', {
					event: 'page_view',
					page: event.url,
				});
				this.userpilotService.reload();
			});
	}
}
